'use es6';

import invariant from 'react-utils/invariant';
import { createTokenString } from 'rich-text-lib/utils/properties';
import { INSERT_PERSONALIZATION_TOKEN, EDIT_PERSONALIZATION_TOKEN } from '../constants/usageTracking';
import { trackInteraction } from '../utils/usageTracking';
import { getDefaultValueType } from './utils';
import { generateInnerTokenWithTextNode } from '../utils/token';
import { getHsPersonalizeSettings } from '../utils';
import { hsPersonalizeConfig } from '../constants/hspersonalize';
const getUndefined = () => undefined;
const getFilter = (editor, originalProperty = {}) => {
  const settings = getHsPersonalizeSettings(editor);
  const propertyTypeFiltersCallBack = settings && settings[hsPersonalizeConfig.PROPERTY_FILTERS_CALLBACK] || getUndefined;
  const filter = propertyTypeFiltersCallBack(originalProperty);
  invariant(['undefined', 'string'].includes(typeof filter), 'hsPersonalizeConfig.PROPERTY_FILTERS_CALLBACK must return a STRING');
  return filter;
};
const makeToken = ({
  category,
  name
}, subProperty, defaultValue, filter) => {
  return createTokenString({
    category,
    property: name,
    subProperty,
    defaultValue,
    filter
  });
};
export const getHandleUpdate = editor => function handleUpdate(fullToken, subProperty = '', defaultValue = '') {
  const {
    fieldType = '',
    category: tokenCategory,
    name: tokenName,
    originalProperty,
    isHubspotDefined
  } = fullToken;
  const filter = getFilter(editor, originalProperty);
  const selectionPlaceholder = editor.selection.getNode();
  const textTokenNode = document.createTextNode(makeToken(fullToken, subProperty, defaultValue, filter));
  const innerToken = generateInnerTokenWithTextNode(selectionPlaceholder, textTokenNode);

  // New token can either be a text node or an HTML element
  const newContent = innerToken.nodeType === 3 ? innerToken.textContent : innerToken.outerHTML;
  editor.insertContent(newContent);
  trackInteraction(editor, 'tinymceEditPersonalizationToken', EDIT_PERSONALIZATION_TOKEN, {
    version: 'v3',
    tokenCategory,
    tokenName,
    isHubspotDefined,
    defaultValueType: getDefaultValueType(defaultValue),
    fieldType
  });
};
export const getHandleInsert = editor => function handleInsert(fullToken, subProperty = '', defaultValue = '') {
  const {
    fieldType = '',
    category: tokenCategory,
    name: tokenName,
    originalProperty,
    isHubSpotDefined: isHubspotDefined
  } = fullToken;
  if (!fullToken) {
    throw new Error('[hspersonalize] missing insert token');
  }
  const filter = getFilter(editor, originalProperty);
  editor.insertContent(makeToken(fullToken, subProperty, defaultValue, filter));
  trackInteraction(editor, 'tinymceInsertPersonalizationToken', INSERT_PERSONALIZATION_TOKEN, {
    version: 'v3',
    tokenCategory,
    tokenName,
    isHubspotDefined,
    defaultValueType: getDefaultValueType(defaultValue),
    fieldType
  });
};
export const getTokenRemoveHandler = editor => function handleTokenRemove(token) {
  editor.undoManager.transact(() => {
    editor.dom.remove(token);
  });
};